import PropTypes from "prop-types";
import { CustomContainer } from "../../../DependencyHelper";
import { getValueLabel, getTotalDuration } from "../../../../../utils/helperServices";
import formStyles from "../CreditCheckDetails.module.scss";
import { journeyType } from "../../../../../context/checkout-journey-context";

const HomeDetailsInfo = ({ data, stateTypesOptions, residenceTypes, currentJourneyType }) => {
  return (
    <CustomContainer className={`${formStyles["form-details-container"]}`}>
      <CustomContainer className="row">
        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Unit no. & complex name:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>
            {!data?.unitNo && !data?.complexName
              ? "-"
              : data?.unitNo + " " + data?.complexName}
          </span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Street no. & street name:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>
            {data?.streetNo} {data?.streetName}
          </span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Suburb & postal code:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>
            {data?.suburb}, {data?.postalCode}
          </span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Town / City:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.town}</span>
        </CustomContainer>


        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Province:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{getValueLabel(data?.province, stateTypesOptions)}</span>
        </CustomContainer>

        {currentJourneyType != journeyType.addLine &&  (<CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Property ownership type:</label>
        </CustomContainer>)}
        {currentJourneyType != journeyType.addLine &&  (<CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{!data?.residence? "-" : getValueLabel(data?.residence, residenceTypes)}</span>
        </CustomContainer>)}

        {currentJourneyType != journeyType.addLine &&  (<CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Period at current address:</label>
        </CustomContainer>)}
        {currentJourneyType != journeyType.addLine &&  (<CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.currentAddressYears.toLowerCase()+", "+data?.currentAddressMonths.toLowerCase()}</span>
        </CustomContainer>)}


        {currentJourneyType != journeyType.addLine &&  (<CustomContainer className={`${formStyles["pb-6"]} col-md-6 col-sm-12`}>
          <label>Period at previous address:</label>
        </CustomContainer>)}
        {currentJourneyType != journeyType.addLine &&  (<CustomContainer className={`col-md-6 col-sm-12`}>
          <span>{data?.previousAddressYears.toLowerCase()+", "+data?.previousAddressMonths.toLowerCase()}</span>
        </CustomContainer>)}
      </CustomContainer>
    </CustomContainer>
  );
};

HomeDetailsInfo.propTypes = {
  data: PropTypes.object,
};

HomeDetailsInfo.defaultProps = {
  data: {},
};

export default HomeDetailsInfo;
